<template>
  <div :class="componentClass">
    <label v-if="propType" :for="propType.id" :class="labelClass">{{ displayName ?? propType.name }} <i v-if="propType && propType.description" class="material-icons info" v-b-tooltip :title="propType.description">info</i></label>
    <div :class="controlClass">
      <label class="switcher switcher-sm m-0">
        <input
          type="checkbox" :id="propType.id" class="switcher-input" :disabled="disabled"
          :checked="normalizedValue" @input="change"
        >
        <span class="switcher-indicator"><span class="switcher-yes"></span><span class="switcher-no"></span></span>
      </label>
    </div>
  </div>
</template>

<script>
import { isAllowed } from '@/utils'

export default {
  name: 'BooleanProperty',
  components: {},
  props: {
    value: { type: Boolean },
    propType: { type: Object },
    displayName: { type: String },
    componentClass: { type: String },
    labelClass: { type: String },
    controlClass: { type: String },
    disabled: { type: Boolean }
  },
  data () {
    return {}
  },
  computed: {
    normalizedValue () {
      if (!this.value) return false
      return !!isAllowed(this.value)
    }
  },
  async mounted () {},
  methods: {
    change (evt) {
      this.$emit('input', !!isAllowed(evt.target.checked))
    }
  },
  watch: {}
}
</script>
